import { useContext } from 'react';
import SectionContext from '../../SectionContext';
import useSectionMoving from './useSectionMoving';
import MoveModeContext from '../../../../MoveModeContext';
import MoveButtons from '../../PositionMoveButtons';

const SectionPositionMoving = () => {
  const { previousSection, nextSection } = useContext(SectionContext);
  const [moveUp, moveDown] = useSectionMoving();

  const inMoveMode = useContext(MoveModeContext);
  if (!inMoveMode) {
    return null;
  }

  return (
    <MoveButtons.Wrapper>
      {previousSection && <MoveButtons.Up onClick={moveUp} />}
      {nextSection && <MoveButtons.Down onClick={moveDown} />}
    </MoveButtons.Wrapper>
  );
};

export default SectionPositionMoving;
